/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAdultChild = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM4 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3 6a3 3 0 0 1 3 3v2H8v4H6v-4H4v-2a3 3 0 0 1 3-3zm3 7h2v-4a5 5 0 0 0-10 0v4h2v4h6v-4zm8-3a2 2 0 0 1 2 2h-1v3h-2v-3h-1a2 2 0 0 1 2-2zm3 4h1v-2a4 4 0 1 0-8 0v2h1v3h6v-3zM17 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAdultChild as AdultChild };
